const wowApp = require('angular').module('wowApp.common');

wowApp.directive('wowErrorPage', ['$sce', '$timeout', 'SettingsService', 'ShopPageStateService', 'LoadingIndicatorService', '$state', 'PageMetadataService', require('./errorpage.directive')]);



// WEBPACK FOOTER //
// ./src/common/errorpage/index.js